import React, { useState } from 'react';
import { SearchNormal1, ArrowDown2, TickCircle, ArrowLeft2, ArrowRight2 } from 'iconsax-react';

const FILTRI_PAG  = ['Tutto', 'Pagato', 'Non pagato'];
const MESI_SHORT  = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];
const GIORNI_SHORT = ['Lu','Ma','Me','Gi','Ve','Sa','Do'];

function MiniCalendar({ selectedDate, onSelect }) {
    const [cursor, setCursor] = useState(selectedDate || new Date());
    const year  = cursor.getFullYear();
    const month = cursor.getMonth();

    const firstDay    = new Date(year, month, 1);
    const startOffset = (firstDay.getDay() + 6) % 7;
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const cells = [];
    for (let i = 0; i < startOffset; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(d);

    const today = new Date();
    const sel   = selectedDate || new Date();

    const isToday    = d => d === today.getDate() && month === today.getMonth() && year === today.getFullYear();
    const isSelected = d => d === sel.getDate()   && month === sel.getMonth()   && year === sel.getFullYear();

    return (
        <div style={{ padding: '12px 12px 8px', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                <button onClick={() => setCursor(new Date(year, month - 1, 1))} style={miniNavBtn}>
                    <ArrowLeft2 size={12} color="#888" />
                </button>
                <span style={{ fontSize: 13, fontWeight: 700, color: '#222' }}>
                    {MESI_SHORT[month]} {year}
                </span>
                <button onClick={() => setCursor(new Date(year, month + 1, 1))} style={miniNavBtn}>
                    <ArrowRight2 size={12} color="#888" />
                </button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2, marginBottom: 4 }}>
                {GIORNI_SHORT.map(g => (
                    <div key={g} style={{ textAlign: 'center', fontSize: 10, fontWeight: 600, color: '#bbb' }}>{g}</div>
                ))}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 }}>
                {cells.map((d, i) => (
                    <button
                        key={i} disabled={!d}
                        onClick={() => d && onSelect && onSelect(new Date(year, month, d))}
                        style={{
                            width: '100%', aspectRatio: '1', border: 'none', padding: 0,
                            borderRadius: '50%', fontSize: 11, fontWeight: isSelected(d) ? 700 : 400,
                            background: isSelected(d) ? '#FF5E4B' : isToday(d) ? '#FFF0EE' : 'transparent',
                            color: isSelected(d) ? '#fff' : isToday(d) ? '#FF5E4B' : d ? '#444' : 'transparent',
                            cursor: d ? 'pointer' : 'default',
                        }}
                    >{d || ''}</button>
                ))}
            </div>
        </div>
    );
}

const miniNavBtn = {
    background: 'none', border: 'none', cursor: 'pointer', padding: 4,
    display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 4,
};

export default function FilterPanel({
    view,
    risorse = { impianti: [], maestri: [], corsi: [] },
    checkedIds = {},
    onToggleRisorsa,
    onToggleSection,
    filtroStatoLabel = 'Tutto',
    onFiltroStato,
    selectedDate,
    onDateSelect,
    mostraGenerici = true,
    onToggleGenerici,
}) {
    const [expanded, setExpanded] = useState({ impianti: true, lezioni: true, corsi: true });
    const [search,   setSearch]   = useState('');

    const toggle = key => setExpanded(p => ({ ...p, [key]: !p[key] }));

    const filterItems = (items) =>
        !search ? items : items.filter(r => r.nome?.toLowerCase().includes(search.toLowerCase()));

    const dedupeById = (rows) => {
        const map = new Map();
        (rows || []).forEach(r => {
            const prev = map.get(r.id);
            if (prev) {
                prev.count += r.conteggioEventi ?? 0;
            } else {
                map.set(r.id, {
                    id: r.id, nome: r.nome, count: r.conteggioEventi ?? 0,
                    checked: checkedIds[r.id] !== false,
                });
            }
        });
        return Array.from(map.values());
    };

    const impiantiItems = filterItems(dedupeById(risorse.impianti).filter(r => r.count > 0));
    const maestriItems  = filterItems(dedupeById(risorse.maestri).filter(r => r.count > 0));
    const corsiItems    = filterItems(dedupeById(risorse.corsi).filter(r => r.count > 0));

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fff' }}>

            {(view === 'giorno' || view === 'ora') && (
                <MiniCalendar selectedDate={selectedDate} onSelect={onDateSelect} />
            )}

            <div style={{ padding: '16px 16px 12px' }}>
                <div style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    background: '#F5F5F5', border: '1px solid #EBEBEB',
                    borderRadius: 8, padding: '7px 12px',
                }}>
                    <SearchNormal1 size={14} color="#aaa" />
                    <input
                        value={search} onChange={e => setSearch(e.target.value)}
                        placeholder="Cerca"
                        style={{ border: 'none', background: 'transparent', outline: 'none', fontSize: 13, color: '#555', flex: 1, minWidth: 0 }}
                    />
                </div>
            </div>

            <div style={{ padding: '0 16px 14px', display: 'flex', gap: 4 }}>
                {FILTRI_PAG.map(f => {
                    const active = filtroStatoLabel === f;
                    return (
                        <button key={f} onClick={() => onFiltroStato && onFiltroStato(f)} style={{
                            flex: f === 'Tutto' ? 'none' : 1,
                            padding: '5px 10px', fontSize: 12, fontWeight: active ? 700 : 500,
                            border: 'none', borderRadius: 6,
                            background: active ? '#222' : '#f4f4f4',
                            color: active ? '#fff' : '#888', cursor: 'pointer', whiteSpace: 'nowrap',
                        }}>
                            {f}
                        </button>
                    );
                })}
            </div>

            <div style={{ height: 1, background: '#f0f0f0', margin: '0 0 4px' }} />

            <div style={{ flex: 1, overflowY: 'auto' }}>
                <div style={{ borderBottom: '1px solid #f4f4f4' }}>
                    <div
                        onClick={() => onToggleGenerici && onToggleGenerici()}
                        style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '11px 16px', cursor: 'pointer' }}
                    >
                        {mostraGenerici ? (
                            <TickCircle size={18} color="#7B1FA2" variant="Bulk" style={{ flexShrink: 0 }} />
                        ) : (
                            <span style={{
                                width: 18, height: 18, borderRadius: '50%',
                                border: '1.5px solid #ccc', flexShrink: 0, display: 'inline-block',
                            }} />
                        )}
                        <span style={{ flex: 1, fontSize: 13, fontWeight: 700, color: mostraGenerici ? '#222' : '#aaa' }}>
                            Mostra eventi generici
                        </span>
                    </div>
                </div>

                {impiantiItems.length > 0 && (
                    <Section title="Impianti"        color="#FF5E4B" open={expanded.impianti} onToggle={() => toggle('impianti')} items={impiantiItems} onToggleItem={onToggleRisorsa} onToggleAll={onToggleSection} />
                )}
                {maestriItems.length > 0 && (
                    <Section title="Lezioni"         color="#FF5E4B" open={expanded.lezioni}  onToggle={() => toggle('lezioni')}  items={maestriItems}  onToggleItem={onToggleRisorsa} onToggleAll={onToggleSection} />
                )}
                {corsiItems.length > 0 && (
                    <Section title="Corsi e squadre" color="#FF5E4B" open={expanded.corsi}    onToggle={() => toggle('corsi')}    items={corsiItems}    onToggleItem={onToggleRisorsa} onToggleAll={onToggleSection} />
                )}
            </div>
        </div>
    );
}

function Section({ title, color, open, onToggle, items, onToggleItem, onToggleAll }) {
    const allChecked  = items.length > 0 && items.every(i => i.checked);
    const noneChecked = items.length > 0 && items.every(i => !i.checked);

    const handleToggleAll = (e) => {
        e.stopPropagation();
        if (!onToggleAll || items.length === 0) return;
        onToggleAll(items.map(i => i.id), !allChecked);
    };

    return (
        <div style={{ borderBottom: '1px solid #f4f4f4' }}>
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '11px 16px',
            }}>
                <button onClick={onToggle} style={{
                    flex: 1, display: 'flex', alignItems: 'center', gap: 6,
                    background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left',
                }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: '#222' }}>{title}</span>
                    <ArrowDown2 size={14} color="#aaa"
                        style={{ transform: open ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.2s' }} />
                </button>
                {items.length > 0 && (
                    <button
                        onClick={handleToggleAll}
                        style={{
                            background: 'none', border: 'none', cursor: 'pointer', padding: '2px 6px',
                            fontSize: 11, fontWeight: 600,
                            color: allChecked ? '#888' : noneChecked ? color : '#888',
                        }}
                        title={allChecked ? 'Deseleziona tutti' : 'Seleziona tutti'}
                    >
                        {allChecked ? 'Deseleziona' : 'Seleziona'} tutti
                    </button>
                )}
            </div>
            {open && (
                <div style={{ paddingBottom: 8 }}>
                    {items.length === 0 && (
                        <div style={{ padding: '4px 16px', fontSize: 12, color: '#ccc' }}>—</div>
                    )}
                    {items.map((item) => (
                        <div key={item.id}
                            onClick={() => onToggleItem && onToggleItem(item.id)}
                            style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '7px 16px', cursor: 'pointer' }}
                        >
                            {item.checked ? (
                                <TickCircle size={18} color={color} variant="Bulk" style={{ flexShrink: 0 }} />
                            ) : (
                                <span style={{
                                    width: 18, height: 18, borderRadius: '50%',
                                    border: '1.5px solid #ccc', flexShrink: 0, display: 'inline-block',
                                }} />
                            )}
                            <span style={{ flex: 1, fontSize: 13, color: item.checked ? '#222' : '#aaa' }}>
                                {item.nome}
                            </span>
                            <span style={{ fontSize: 12, color: '#bbb', fontWeight: 500 }}>
                                {item.count}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
